import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { Plus, PlusIcon } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import XCloseIcon from "../../../../component/icons/x-close";
import * as XLSX from "xlsx";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import StatusChip from "../../../../component/ui/chip/status";
import Tooltip from "../../../../component/ui/tooltip";
import InvoiceQuickView from "../../../../component/invoice/InvoiceQuickView";
import { CustomDropdown } from "../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../component/ui/dropdown/CustomDropdownButton";
import DotsVerticalIcon from "../../../../component/icons/dots-vertical";
import { CustomDropdownMenu } from "../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../component/ui/dropdown/CustomDropdownMenuList";
import ChevronDownIcon from "../../../../component/icons/chevron-down";
import FileCode1Icon from "../../../../component/icons/file-code-1";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import AddTask from "./addTask";
import UpdateSubTask from "./updateSubTask";
import TaskQuickView from "../task-popup";
import SubTaskQuickView from "../sub-task-popup";

const ProjectTask = ({ projectKey }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [changeModal, setChangeModal] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [currentStatus, setCurrentStatus] = useState("");
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [tableHeader, setTableHeader] = useState([]);
  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [exportTo, setExportTo] = useState(false);

  const [invoicePopup, setInvoicePopup] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  const [pageItemsCount, setPageItemsCount] = useState(10);
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);

  const [editTaskData, setEditTaskData] = useState({});
  const [users, setUsers] = useState([]);

  const toggleSelectAll = (checked) => {
    if (checked) {
      setSelectedProjects(apiData.map((d) => d.projectkey));
    } else {
      setSelectedProjects([]);
    }
  };

  // ✅ Toggle Single Row
  const toggleSelectRow = (projectKey) => {
    setSelectedProjects((prev) =>
      prev.includes(projectKey)
        ? prev.filter((id) => id !== projectKey)
        : [...prev, projectKey]
    );
  };

  const handleExport = async (type, localData = null) => {
    try {
      // ✅ If user already selected rows (local data)
      if (localData && localData.length > 0) {
        exportData(localData, type);
        return;
      }

      const filters = filterReturn || [];
      const page = 1;
      const page_quantity = "all";

      const data = { page, page_quantity, filters };

      Swal.fire({
        title: "Exporting Projects...",
        text: "Please wait while we export your data.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // 🧩 Convert filters array → object
      const filtersObj = data.filters.reduce((acc, f) => {
        if (f.value !== "" && f.value !== null && f.value !== undefined) {
          acc[f.field] = f.value;
        }
        return acc;
      }, {});

      const transformed = {
        page_quantity: String(data.page_quantity || ""),
        page: String(data.page || "1"),
        ...filtersObj,
      };

      const apiData = JSON.stringify(transformed);

      const res = await apiCall({
        url: `projects/projects-list`,
        method: "post",
        data: apiData,
      });

      const projectsData = res?.data || res?.projects || [];
      if (!projectsData?.length) {
        Swal.fire({
          title: "Warning!",
          text: "No project data available to export.",
          icon: "warning",
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: { confirmButton: Style.customSwalBtn },
        });
        return;
      }

      exportData(projectsData, type);
    } catch (error) {
      console.error("Export Error:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while exporting.",
        icon: "error",
        confirmButtonText: "OK",
        buttonsStyling: false,
        customClass: { confirmButton: Style.customSwalBtn },
      });
    }
  };

  const exportData = (data, type) => {
    const visibleColumns = tableHeader
      ?.filter((col) => col.is_visible === 1 && col.show == 1)
      ?.map((col) => ({ key: col.key, label: col.value }));

    const formattedData = data.map((row) => {
      const obj = {};

      obj["Customer Name"] = row?.customer_details?.name || "-";
      obj["Customer Email"] = row?.customer_details?.email || "-";
      obj["Customer Phone"] = row?.customer_details?.phone || "-";

      visibleColumns.forEach(({ key, label }) => {
        if (
          [
            "project_name",
            "customer_details",
            "customer_name",
            "customer_email",
            "customer_phone",
          ].includes(key)
        )
          return; // skip duplicates

        if (key === "agent_details") {
          obj[label || "Agent"] = row?.agent_details?.name || "-";
        } else if (key === "package_details") {
          obj[label || "Package"] = row?.package_details?.packagename || "-";
        } else if (key === "status") {
          obj[label || "Status"] = row?.status || "-";
        } else if (key === "payment") {
          obj[label || "Payment"] = row?.payment || "-";
        } else if (key === "invoiceid") {
          obj[label || "Invoice ID"] = row?.invoiceid || "-";
        } else if (["created_at", "signupdate"].includes(key)) {
          obj[label || key] = row[key]
            ? dayjs(row[key]).format("DD-MMM-YYYY")
            : "-";
        } else {
          obj[label || key] =
            typeof row[key] === "object" && row[key] !== null
              ? JSON.stringify(row[key])
              : row[key] ?? "-";
        }
      });

      return obj;
    });

    // 📁 File name
    const fileName = `projects_${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, "-")}`;

    // 💾 Export logic
    if (type === "csv") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const csvContent = XLSX.utils.sheet_to_csv(worksheet);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.csv`;
      link.click();
    } else if (type === "excel") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }

    Swal.fire({
      title: "Success!",
      text: "Project data exported successfully.",
      icon: "success",
      confirmButtonText: "OK",
      buttonsStyling: false,
      customClass: { confirmButton: Style.customSwalBtn },
    });
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    getProducts();
    getBrands();
    getUsers();
  }, []);

  const getUsers = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });
      setUsers(res?.agents);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 10 };
    let extraUrl = `?page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    const baseUrl = `tasks/tasks-list?project_key=${projectKey}`;

    try {
      const res = await apiCall({
        method: "get",
        url: `${baseUrl}${extraUrl.replace("?", "&")}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res?.data);
      }
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
    setShowAddTaskModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const removeFilter = (fIndex) => {
    let allFilter = [...filterReturn];
    allFilter.splice(fIndex, 1);
    setFilterReturn(allFilter);
    getData({ filter: allFilter });
  };

  const getProducts = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });

      setProducts(res?.data || []);
    } catch (error) {
      console.warn("Error fetching Products:", error);
    }
  };

  const getBrands = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "brands/brands-list?is_paginate=0",
      });

      setBrands(res?.data || []);
    } catch (error) {
      console.warn("Error fetching brands:", error);
    }
  };

  const filterModalData = [
    {
      name: "task_name",
      label: "Name",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: apiData,
      dropdownKey: "task_name",
      dropdownVal: "task_name",
    },
    {
      name: "task_status",
      label: "Task Status",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Pending", value: "pending" },
        { label: "Completed", value: "completed" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
    },
    {
      name: "priority",
      label: "Priority",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "High", value: "High" },
        { label: "Medium", value: "Medium" },
        { label: "Low", value: "Low" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
    },
    {
      name: "deadline",
      label: "Deadline",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "date",
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },

    {
      name: "username",
      label: "Username",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "text",
    },
  ];

  const editTask = (eachList) => {
    setEditTaskData(eachList);
    setShowAddTaskModal(true);
  };

  const tableRef = useRef(null);

  const [expandedRows, setExpandedRows] = useState([]);
  const [subTaskModal, setSubTaskModal] = useState(false);
  const [subTaskData, setSubTaskData] = useState({});
  const [subTaskPopup, setSubTaskPopup] = useState(false);
  const [subTaskPopupData, setSubTaskPopUpData] = useState({});

  const toggleRow = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const editSubTask = (eachList) => {
    setSubTaskData(eachList);
    setSubTaskModal(true);
  };

  return (
    <>
      <div className={`${Style.mainBody} !max-h-screen overflow-auto `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {isLoading ? (
                <div className="flex flex-col justify-center items-center h-28 bg-gray-50 rounded-xl shadow-sm border border-gray-200 p-4">
                  <InnerLoader />
                </div>
              ) : !apiData.length ? (
                <>
                  <div className="flex flex-col justify-center items-center h-28 bg-gray-50 rounded-xl shadow-sm border border-gray-200 p-4">
                    <DataNotFound title="Task" />

                    <button
                      className="mt-3 bg-[#0057FB] hover:bg-[#0047d6] transition-all duration-200 
               text-white text-sm font-medium py-2 px-3 rounded-lg 
               flex items-center gap-2 shadow-md hover:shadow-lg"
                      onClick={() => setShowAddTaskModal(true)}
                    >
                      <Plus className="h-4 w-4" />
                      Add Task
                    </button>
                  </div>
                </>
              ) : (
                <>
                  {/* HEADER */}
                  <div className={Style.empDirectory_header}>
                    <div className={Style.empDirectory_header_left}>
                      <div className="flex gap-1 p-3 items-center">
                        <h2 className="font-medium text-[22px]">
                          Project Task
                        </h2>
                        {apiData?.length > 0 ? (
                          <p className="bg-[#0057FB] font-light rounded-xl py-[6px] px-[12px] text-white">
                            {apiData.length}
                          </p>
                        ) : (
                          <Skeleton
                            style={{
                              padding: "15px 17px",
                              borderRadius: "100%",
                            }}
                          />
                        )}
                      </div>

                      

                      <TableFilterReturn
                        filterReturn={filterReturn}
                        onChange={(allFilter) => {
                          setFilterReturn(allFilter);

                          getData({ filter: allFilter });
                        }}
                      />
                    </div>

                    <div className={Style.empDirectory_header_right}>
                      <div className={Style.bpfl_action}>
                        <div
                          className={Style.bpfl_action}
                          onClick={() => setShowAddTaskModal(true)}
                        >
                          <Tooltip
                            content={"Add Task"}
                            position={"left center"}
                            className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                          >
                            <div className={Style.icon}>
                              <PlusIcon size="1em" />
                            </div>
                          </Tooltip>
                        </div>

                        <Tooltip
                          className={Style.bpfl_actionItems}
                          content={"Table Filter"}
                          position={"left center"}
                        >
                          <div
                            className={`${Style.bpfl_actionBtn} ${
                              filterReturn?.length ? Style.active : null
                            }`}
                            onClick={() => {
                              setShowModalFilterTable(true);
                            }}
                          >
                            <div className={Style.icon}>
                              <FilterFunnel01Icon />
                            </div>
                          </div>
                        </Tooltip>

                        <Tooltip
                          className={`${Style.bpfl_actionItems}`}
                          content={"Customize Table"}
                          position={"left center"}
                        >
                          <div
                            className={`${Style.bpfl_actionBtn}`}
                            onClick={() => {
                              setShowModalCustomizeTabs(true);
                            }}
                          >
                            <div className={Style.icon}>
                              <LayoutTopIcon />
                            </div>
                          </div>
                        </Tooltip>

                        <CustomDropdown
                          position="bottom-right"
                          className={`myDropdown`}
                        >
                          <CustomDropdownButton
                            arrow={false}
                            className="btnClass"
                          >
                            <DotsVerticalIcon />
                          </CustomDropdownButton>

                          <CustomDropdownMenu>
                            <CustomDropdownMenuList
                              className={Style.CustomDropdownMenuList}
                              closed={false}
                            >
                              <div
                                className={Style.CustomDropdownMenuListBtn}
                                onClick={() => setExportTo(!exportTo)}
                              >
                                <div className="">
                                  <LayoutTopIcon /> Export to
                                </div>
                                <div
                                  className={`${Style.dropArrow} ${
                                    exportTo ? Style.isActive : null
                                  }`}
                                >
                                  <ChevronDownIcon />
                                </div>
                              </div>

                              {exportTo ? (
                                <div className={Style.subItemMenu}>
                                  <CustomDropdownMenuList
                                    className={Style.subItemList}
                                    onClick={() => {
                                      const dataToExport =
                                        selectedProjects.length > 0
                                          ? apiData.filter((d) =>
                                              selectedProjects.includes(
                                                d.projectid
                                              )
                                            )
                                          : apiData;

                                      // ✅ Call the new unified export function
                                      handleExport("csv", dataToExport);
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-1">
                                      <FileCode1Icon /> CSV
                                    </div>
                                  </CustomDropdownMenuList>

                                  <CustomDropdownMenuList
                                    className={Style.subItemList}
                                    onClick={() => {
                                      const dataToExport =
                                        selectedProjects.length > 0
                                          ? apiData.filter((d) =>
                                              selectedProjects.includes(
                                                d.projectid
                                              )
                                            )
                                          : apiData;

                                      // ✅ Call the new unified export function
                                      handleExport("excel", dataToExport);
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-1">
                                      <FileCode1Icon /> XLSX
                                    </div>
                                  </CustomDropdownMenuList>
                                </div>
                              ) : null}
                            </CustomDropdownMenuList>
                          </CustomDropdownMenu>
                        </CustomDropdown>
                      </div>
                    </div>
                  </div>

                  {/* BODY */}
                  <div className={Style.empDirectory_body}>
                    {isLoading ? (
                      <InnerLoader />
                    ) : !apiData?.length ? (
                      <DataNotFound title={"Projects"} />
                    ) : (
                      <>
                        <TableCard ref={tableRef}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell header sticky>
                                  <div className="flex gap-2 items-center">
                                    <div className={Style.tableCheckBox}>
                                      <label className={Style.custom_checkbox}>
                                        <input
                                          type="checkbox"
                                          checked={
                                            selectedProjects.length ===
                                              apiData.length &&
                                            apiData.length > 0
                                          }
                                          className={Style.customCheckbox}
                                          onChange={(e) =>
                                            toggleSelectAll(e.target.checked)
                                          }
                                        />
                                        <span
                                          className={Style.checkmark}
                                        ></span>
                                      </label>
                                    </div>
                                    <TableHeaderWrap>
                                      <span className="pl-[50px]">Name</span>
                                    </TableHeaderWrap>
                                  </div>
                                </TableCell>
                                {tableHeader?.map((eachHead, index) =>
                                  eachHead.is_visible === 1 &&
                                  eachHead?.show == 1 ? (
                                    <TableCell header key={index}>
                                      <TableHeaderWrap>
                                        <span>{eachHead?.value}</span>
                                      </TableHeaderWrap>
                                    </TableCell>
                                  ) : null
                                )}
                                <TableCell header>
                                  <TableHeaderWrap>
                                    <span className="pl-[50px]">Sub Tasks</span>
                                  </TableHeaderWrap>
                                </TableCell>
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {apiData?.map((eachList, index) => {
                                return (
                                  <>
                                    <TableRow key={`${index}`}>
                                      <TableCell sticky>
                                        <div
                                          className={`${Style.tableActionArea} !gap-4`}
                                        >
                                          <div className="flex gap-2 items-center">
                                            <div
                                              className={Style.tableCheckBox}
                                            >
                                              <label
                                                className={
                                                  Style.custom_checkbox
                                                }
                                              >
                                                <input
                                                  type="checkbox"
                                                  className={
                                                    Style.customCheckbox
                                                  }
                                                  checked={selectedProjects.includes(
                                                    eachList.projectkey
                                                  )}
                                                  onChange={() =>
                                                    toggleSelectRow(
                                                      eachList.projectkey
                                                    )
                                                  }
                                                />
                                                <span
                                                  className={Style.checkmark}
                                                ></span>
                                              </label>
                                            </div>

                                            <div className="flex items-center gap-3">
                                              <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center">
                                                {eachList?.customer_details
                                                  ?.userimg ? (
                                                  <img
                                                    className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                                    src={
                                                      eachList?.customer_details
                                                        ?.userimg
                                                    }
                                                    alt={eachList?.task_name}
                                                    onError={(e) => {
                                                      e.target.classList.add(
                                                        "hidden"
                                                      );
                                                      if (
                                                        e.target.parentElement
                                                      ) {
                                                        e.target.parentElement.innerHTML = `
                                <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                  ${
                                    eachList?.task_name.split(" ")[0]?.[0] || ""
                                  }${
                                                          eachList?.task_name.split(
                                                            " "
                                                          )[1]?.[0] || ""
                                                        }
                                </div>`;
                                                      }
                                                    }}
                                                  />
                                                ) : (
                                                  <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                    {eachList?.task_name.split(
                                                      " "
                                                    )[0]
                                                      ? eachList?.task_name.split(
                                                          " "
                                                        )[0][0]
                                                      : ""}
                                                    {eachList?.name?.split(
                                                      " "
                                                    )[1]
                                                      ? eachList?.task_name.split(
                                                          " "
                                                        )[1][0]
                                                      : ""}
                                                  </div>
                                                )}
                                              </div>

                                              <div className="font-medium leading-5">
                                                {eachList?.task_name}
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            className={
                                              Style.tableActionAreaBtnGrpup
                                            }
                                          >
                                            <div
                                              className={
                                                "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                              }
                                              onClick={() => {
                                                editTask(eachList);
                                              }}
                                            >
                                              <div
                                                className={Style.icon}
                                                style={{
                                                  color: "#FF9500",
                                                }}
                                              >
                                                <NewEditIcon className="h-4.5 w-4.5" />
                                              </div>
                                            </div>
                                            <div
                                              className={
                                                "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                              }
                                              onClick={() => {
                                                setEmpPopup(true);
                                                setEmpData(eachList);
                                              }}
                                            >
                                              <div
                                                className={Style.icon}
                                                style={{ color: "#007AFF" }}
                                              >
                                                <NewEyeIcon className="h-4.5 w-4.5" />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </TableCell>

                                      {tableHeader?.map((eachHead, i) =>
                                        eachHead.is_visible === 1 &&
                                        eachHead?.show == 1 ? (
                                          <>
                                            {eachHead.key === "task_status" ? (
                                              <TableCell
                                                key={`${i}-${index}`}
                                                className="text-center capitalize"
                                              >
                                                {eachList[eachHead?.key] ===
                                                "pending" ? (
                                                  <StatusChip color="blue">
                                                    {eachList[eachHead?.key] ||
                                                      "--"}
                                                  </StatusChip>
                                                ) : eachList[eachHead?.key] ===
                                                  "completed" ? (
                                                  <StatusChip color="green">
                                                    {eachList[eachHead?.key] ||
                                                      "--"}
                                                  </StatusChip>
                                                ) : eachList[eachHead?.key] ===
                                                  "cancelled" ? (
                                                  <StatusChip color="red">
                                                    {eachList[eachHead?.key] ||
                                                      "--"}
                                                  </StatusChip>
                                                ) : (
                                                  "-"
                                                )}
                                              </TableCell>
                                            ) : eachHead.key === "priority" ? (
                                              <TableCell
                                                key={`${i}-${index}`}
                                                className="text-center capitalize"
                                              >
                                                {eachList.priority ? (
                                                  <StatusChip
                                                    color={
                                                      eachList?.priority ==
                                                      "low"
                                                        ? "green"
                                                        : eachList?.priority ==
                                                          "medium"
                                                        ? "yellow"
                                                        : eachList?.priority ==
                                                          "high"
                                                        ? "red"
                                                        : null
                                                    }
                                                  >
                                                    {eachList[eachHead?.key] ||
                                                      "--"}
                                                  </StatusChip>
                                                ) : (
                                                  "-"
                                                )}
                                              </TableCell>
                                            ) : eachHead.key ===
                                              "assigned_users" ? (
                                              <>
                                                <TableCell
                                                  key={`${i}-${index}`}
                                                >
                                                  <div className="flex">
                                                    {Array.isArray(
                                                      eachList?.assigned_users
                                                    ) &&
                                                    eachList?.assigned_users
                                                      ?.length > 0 ? (
                                                      eachList?.assigned_users?.map(
                                                        (each, idx) => (
                                                          <Tooltip
                                                            key={idx}
                                                            content={
                                                              each?.user?.name
                                                            }
                                                            position="top center"
                                                          >
                                                            <div
                                                              className={`relative ${
                                                                idx !== 0
                                                                  ? "-ml-2"
                                                                  : ""
                                                              }`}
                                                            >
                                                              {each?.user
                                                                ?.userimg ? (
                                                                <img
                                                                  src={
                                                                    each?.user
                                                                      ?.userimg
                                                                  }
                                                                  alt={
                                                                    each?.user
                                                                      .name
                                                                  }
                                                                  className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                                                                  onError={(
                                                                    e
                                                                  ) => {
                                                                    e.target.onerror =
                                                                      null;
                                                                    e.target.style.display =
                                                                      "none";
                                                                    const fallback =
                                                                      document.createElement(
                                                                        "div"
                                                                      );
                                                                    fallback.className =
                                                                      "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm";
                                                                    fallback.innerText =
                                                                      (
                                                                        (each?.user?.name?.split(
                                                                          " "
                                                                        )[0]?.[0] ||
                                                                          "") +
                                                                        (each?.user?.name?.split(
                                                                          " "
                                                                        )[1]?.[0] ||
                                                                          "")
                                                                      ).toUpperCase();
                                                                    e.target.parentElement.appendChild(
                                                                      fallback
                                                                    );
                                                                  }}
                                                                />
                                                              ) : (
                                                                <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                                                                  {(each?.user?.name?.split(
                                                                    " "
                                                                  )[0]?.[0] ||
                                                                    "") +
                                                                    (each?.user?.name?.split(
                                                                      " "
                                                                    )[1]?.[0] ||
                                                                      "")}
                                                                </div>
                                                              )}
                                                            </div>
                                                          </Tooltip>
                                                        )
                                                      )
                                                    ) : (
                                                      <span className="text-gray-400 text-sm">
                                                        -
                                                      </span>
                                                    )}
                                                  </div>
                                                </TableCell>
                                              </>
                                            ) : eachHead.key === "sub_tasks" ? (
                                              <TableCell key={`${i}-${index}`}>
                                                {"-"}
                                              </TableCell>
                                            ) : (
                                              <TableCell key={`${i}-${index}`}>
                                                {eachList[eachHead?.key] ?? "-"}
                                              </TableCell>
                                            )}
                                          </>
                                        ) : null
                                      )}
                                      <TableCell>
                                        <button
                                          onClick={() => {
                                            toggleRow(eachList?.task_id);
                                          }}
                                          className={`
                                              flex items-center justify-between gap-2
                                              px-3 py-1.5
                                              bg-white hover:bg-white/50
                                              border border-gray-300
                                              rounded-md
                                              text-sm font-medium text-gray-700
                                              transition-all duration-300
                                            `}
                                        >
                                          <span className="flex items-start gap-1">
                                            Sub Tasks
                                            <b className="text-gray-400 text-[10px]">
                                              ({eachList?.sub_tasks?.length})
                                            </b>
                                          </span>
                                          <div
                                            className={`${
                                              expandedRows.includes(
                                                eachList?.task_id
                                              )
                                                ? "rotate-180"
                                                : ""
                                            } transition-transform duration-300`}
                                          >
                                            <ChevronDownIcon className="h-4.5 w-4.5 text-gray-500" />
                                          </div>
                                        </button>
                                      </TableCell>
                                    </TableRow>

                                    {/* Drill Table */}
                                    {expandedRows.includes(
                                      eachList?.task_id
                                    ) && (
                                      <TableRow
                                        key={`drill-${eachList?.task_id}`}
                                        className={`${Style.drillRow} !bg-[#F7F7F7] !pr-3`}
                                      >
                                        <TableCell
                                          colSpan={tableHeader?.length}
                                          className={"!bg-[#F7F7F7]"}
                                        >
                                          {eachList?.sub_tasks?.length ? (
                                            <div className="p-3 rounded-lg border border-gray-200 bg-white shadow-sm">
                                              <Table className="w-full border-collapse">
                                                <TableHead>
                                                  <TableRow>
                                                    <TableCell header>
                                                      <div className="pl-10">
                                                        Sub Tasks
                                                      </div>
                                                    </TableCell>
                                                    <TableCell header>
                                                      Description
                                                    </TableCell>
                                                    <TableCell header>
                                                      Status
                                                    </TableCell>
                                                    <TableCell header>
                                                      Deadline
                                                    </TableCell>

                                                    <TableCell header>
                                                      Priority
                                                    </TableCell>
                                                    <TableCell header>
                                                      Source
                                                    </TableCell>
                                                    <TableCell header>
                                                      Time Stamp
                                                    </TableCell>
                                                    <TableCell header>
                                                      Assigned Users
                                                    </TableCell>
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                  {eachList?.sub_tasks?.map(
                                                    (sp, i) => (
                                                      <TableRow key={`${i}`}>
                                                        <TableCell sticky>
                                                          <div
                                                            className={`${Style.tableActionArea} !gap-4`}
                                                          >
                                                            <div className="flex items-center gap-3">
                                                              <div className="font-medium leading-5 pl-[50px]">
                                                                {
                                                                  sp?.sub_task_name
                                                                }
                                                              </div>
                                                            </div>

                                                            <div
                                                              className={
                                                                Style.tableActionAreaBtnGrpup
                                                              }
                                                            >
                                                              <div
                                                                className={
                                                                  "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                                                }
                                                                onClick={() => {
                                                                  editSubTask(
                                                                    sp
                                                                  );
                                                                }}
                                                              >
                                                                <div
                                                                  className={
                                                                    Style.icon
                                                                  }
                                                                  style={{
                                                                    color:
                                                                      "#FF9500",
                                                                  }}
                                                                >
                                                                  <NewEditIcon className="h-4.5 w-4.5" />
                                                                </div>
                                                              </div>

                                                              <div
                                                                className={
                                                                  "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                                                }
                                                                onClick={() => {
                                                                  setSubTaskPopup(
                                                                    true
                                                                  );
                                                                  setSubTaskPopUpData(
                                                                    sp
                                                                  );
                                                                }}
                                                              >
                                                                <div
                                                                  className={
                                                                    Style.icon
                                                                  }
                                                                  style={{
                                                                    color:
                                                                      "#007AFF",
                                                                  }}
                                                                >
                                                                  <NewEyeIcon className="h-4.5 w-4.5" />
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </TableCell>
                                                        <TableCell>
                                                          {sp.sub_task_description ??
                                                            "--"}
                                                        </TableCell>
                                                        <TableCell
                                                          key={`${i}-${index}`}
                                                          className="text-center capitalize"
                                                        >
                                                          {sp?.sub_task_status ==
                                                          "pending" ? (
                                                            <StatusChip color="blue">
                                                              {sp?.sub_task_status ||
                                                                "--"}
                                                            </StatusChip>
                                                          ) : sp?.sub_task_status ===
                                                            "completed" ? (
                                                            <StatusChip color="green">
                                                              {sp?.sub_task_status ||
                                                                "--"}
                                                            </StatusChip>
                                                          ) : sp?.sub_task_status ===
                                                            "cancelled" ? (
                                                            <StatusChip color="red">
                                                              {sp?.sub_task_status ||
                                                                "--"}
                                                            </StatusChip>
                                                          ) : (
                                                            "-"
                                                          )}
                                                        </TableCell>
                                                        <TableCell>
                                                          {sp?.deadline ?? "--"}
                                                        </TableCell>
                                                        <TableCell
                                                          key={`${i}-${index}`}
                                                          className="text-center capitalize"
                                                        >
                                                          {sp?.priority ==
                                                          "low" ? (
                                                            <StatusChip color="green">
                                                              {sp?.priority ||
                                                                "--"}
                                                            </StatusChip>
                                                          ) : sp?.priority ===
                                                            "medium" ? (
                                                            <StatusChip color="yellow">
                                                              {sp?.priority ||
                                                                "--"}
                                                            </StatusChip>
                                                          ) : sp?.priority ===
                                                            "high" ? (
                                                            <StatusChip color="red">
                                                              {sp?.priority ||
                                                                "--"}
                                                            </StatusChip>
                                                          ) : (
                                                            "-"
                                                          )}
                                                        </TableCell>

                                                        <TableCell>
                                                          {sp?.source ?? "--"}
                                                        </TableCell>
                                                        <TableCell>
                                                          {sp?.timestamp ??
                                                            "--"}
                                                        </TableCell>
                                                        <TableCell
                                                          key={`${i}-${index}`}
                                                        >
                                                          <div className="flex">
                                                            {Array.isArray(
                                                              sp?.assigned_users
                                                            ) &&
                                                            sp?.assigned_users
                                                              .length > 0 ? (
                                                              sp?.assigned_users.map(
                                                                (each, idx) => (
                                                                  <Tooltip
                                                                    key={idx}
                                                                    content={
                                                                      each?.user
                                                                        ?.name
                                                                    }
                                                                    position="top center"
                                                                  >
                                                                    <div
                                                                      className={`relative ${
                                                                        idx !==
                                                                        0
                                                                          ? "-ml-2"
                                                                          : ""
                                                                      }`}
                                                                    >
                                                                      {each
                                                                        ?.user
                                                                        ?.userimg ? (
                                                                        <img
                                                                          src={
                                                                            each
                                                                              ?.user
                                                                              ?.userimg
                                                                          }
                                                                          alt={
                                                                            each
                                                                              ?.user
                                                                              .name
                                                                          }
                                                                          className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                                                                          onError={(
                                                                            e
                                                                          ) => {
                                                                            e.target.onerror =
                                                                              null;
                                                                            e.target.style.display =
                                                                              "none";
                                                                            const fallback =
                                                                              document.createElement(
                                                                                "div"
                                                                              );
                                                                            fallback.className =
                                                                              "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm";
                                                                            fallback.innerText =
                                                                              (
                                                                                (each?.user?.name?.split(
                                                                                  " "
                                                                                )[0]?.[0] ||
                                                                                  "") +
                                                                                (each?.user?.name?.split(
                                                                                  " "
                                                                                )[1]?.[0] ||
                                                                                  "")
                                                                              ).toUpperCase();
                                                                            e.target.parentElement.appendChild(
                                                                              fallback
                                                                            );
                                                                          }}
                                                                        />
                                                                      ) : (
                                                                        <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                                                                          {(each?.user?.name?.split(
                                                                            " "
                                                                          )[0]?.[0] ||
                                                                            "") +
                                                                            (each?.user?.name?.split(
                                                                              " "
                                                                            )[1]?.[0] ||
                                                                              "")}
                                                                        </div>
                                                                      )}
                                                                    </div>
                                                                  </Tooltip>
                                                                )
                                                              )
                                                            ) : (
                                                              <span className="text-gray-400 text-sm">
                                                                -
                                                              </span>
                                                            )}
                                                          </div>
                                                        </TableCell>
                                                      </TableRow>
                                                    )
                                                  )}
                                                </TableBody>
                                              </Table>
                                            </div>
                                          ) : (
                                            <div className="w-full text-center flex justify-center items-center">
                                              <DataNotFound
                                                title={"Sub Tasks"}
                                              />
                                            </div>
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableCard>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl={`tasks/tasks-list?project_key=${projectKey}`}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl={`tasks/tasks-list?project_key=${projectKey}`}
        />
      )}

      {empPopup && (
        <TaskQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
        />
      )}
      {subTaskPopup && (
        <SubTaskQuickView
          onClose={() => {
            setSubTaskPopup(false);
            setSubTaskPopUpData({});
          }}
          data={subTaskPopupData}
        />
      )}

      {invoicePopup && invoiceData && (
        <InvoiceQuickView
          onClose={() => {
            setInvoicePopup(false);
            setInvoiceData(null);
          }}
          data={invoiceData}
          type="project"
        />
      )}

      {showAddTaskModal && (
        <AddTask
          onClose={() => {
            setShowAddTaskModal(false);
            setEditTaskData({});
          }}
          projectKey={projectKey}
          usersList={users}
          taskData={editTaskData}
          onSubmit={onSuccess}
          onError={onError}
        />
      )}

      {subTaskModal && (
        <UpdateSubTask
          onClose={() => {
            setSubTaskModal(false);
            setSubTaskData({});
          }}
          projectKey={projectKey}
          usersList={users}
          taskData={subTaskData}
          onSubmit={onSuccess}
          onError={onError}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ProjectTask;
